// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3dW0Q){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3Wv6f .dualColumn_DsSSL{display:flex;align-content:space-between}.nsAddressForm_3Wv6f .dualColumn_DsSSL .firstCol_1DYFy{margin-right:20px}.optional_2DVV_{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3dW0Q",
	"nsAddressForm": "nsAddressForm_3Wv6f",
	"dualColumn": "dualColumn_DsSSL",
	"firstCol": "firstCol_1DYFy",
	"optional": "optional_2DVV_"
};
module.exports = exports;
